import { DateTime } from "luxon";
import { ApolloLinkScalar } from "@config/apollo/apollo-link.type";

export const DateScalar: ApolloLinkScalar<DateTime> = {
    parseValue: (value: unknown) => {
        if (typeof value !== "string") return null;
        const dateModel = DateTime.fromISO(value);
        if (dateModel) return dateModel;
        throw new Error("Couldn't parse a date : " + value);
    },
    serialize: (value: unknown) => {
        if (!(value instanceof DateTime)) return null;
        const res = value.toISO();
        if (res) return res;
        throw new Error("Can't serialize the date object");
    },
};
